import React, {FC, useEffect, useId, useState} from "react";
import Glide from "@glidejs/glide";
import slide1 from "images/new-collection/1.jpg";
import slide2 from "images/new-collection/2.jpg";
import slide3 from "images/new-collection/3.jpg";
import slide4 from "images/new-collection/4.jpg";
import slide5 from "images/new-collection/5.jpg";
import slide6 from "images/new-collection/6.jpg";
import slide7 from "images/new-collection/7.jpg";
import slide8 from "images/new-collection/8.jpg";
import ModalPhotos from "../../containers/ProductDetailPage/ModalPhotos";
import ButtonPrimary from "../../shared/Button/ButtonPrimary";

export interface CardCategoryData {
    name?: string;
    desc?: string;
    img: string;
    color?: string;
}
const CATS: CardCategoryData[] = [
    {img: slide1},
    {img: slide2},
    {img: slide3},
    {img: slide4},
    {img: slide5},
    {img: slide6},
    {img: slide7},
    {img: slide8},
];
export interface NewCollectionSliderProps {
    className?: string;
    itemClassName?: string;
    heading?: string;
    subHeading?: string;
    data?: CardCategoryData[];
}

const NewCollectionSlider: FC<NewCollectionSliderProps> = ({
    heading = "Shop by department",
    subHeading = "",
    className = "",
    itemClassName = "",
    data = CATS,
}) => {
    const id = useId();
    const UNIQUE_CLASS = "glidejs" + id.replace(/:/g, "_");

    useEffect(() => {
        // @ts-ignore
        const OPTIONS: Glide.Options = {
            type: "carousel",
            perView: 8,
            gap: 7,
            bound: true,
            autoplay: 5000,
            breakpoints: {
                1280: {
                    perView: 8,
                },
                1024: {
                    gap: 7,
                    perView: 4,
                },
                768: {
                    gap: 7,
                    perView: 4,
                },
                640: {
                    gap: 7,
                    perView: 4,
                },
                500: {
                    gap: 7,
                    perView: 3,
                },
            },
        };

        let slider = new Glide(`.${UNIQUE_CLASS}`, OPTIONS);
        slider.mount();
        return () => {
            slider.destroy();
        };
    }, [UNIQUE_CLASS]);

    let imagesToModal: string[] = [];

    const [isOpenModalPhotos, setIsOpenModalPhotos] = useState(false);
    const [openFocusIndex, setOpenFocusIndex] = useState(0);

    const handleOpenModalPhotos = (index: number) => {
        setIsOpenModalPhotos(true);
        setOpenFocusIndex(index);
    };

    const handleCloseModalPhotos = () => setIsOpenModalPhotos(false);

    return (
        <div className={`nc-SectionSliderCategories ${className}`}>
            <div className={`${UNIQUE_CLASS} flow-root text-center`}>
                <ButtonPrimary className={"mb-5 lg:mb-[3.23rem]"} href='/#l_catalog'>{heading}</ButtonPrimary>
                <div className="glide__track" data-glide-el="track">
                    <ul className="glide__slides">
                        {data.map((item, index) => {
                            imagesToModal.push(item.img);

                            return <li key={index} className={`glide__slide ${itemClassName}`} onClick={() => handleOpenModalPhotos(index)}>
                                <img src={item.img} alt={`Новая коллекция - слайд ${index}`} className="cursor-pointer" />
                            </li>
                        })}
                    </ul>
                </div>
                <div className="slider__bullets glide__bullets bg-green" data-glide-el="controls[nav]">
                    {data.map((item, index) => (
                        <button key={index} className={`slider__bullet glide__bullet`} data-glide-dir={`=${index}`}></button>
                    ))}
                </div>
            </div>

            <ModalPhotos imgs={imagesToModal} onClose={handleCloseModalPhotos} isOpen={isOpenModalPhotos} initFocus={openFocusIndex} uniqueClassName={`nc-HomePage__modal${UNIQUE_CLASS} `} />
        </div>
    );
};

export default NewCollectionSlider;
